import "core-js/modules/es.array.concat.js";
import { z } from 'zod';
import { useApplicationPageMutation } from "./aggregatedData";
export function useDeleteApplicationRequirementAttachment() {
  var _useApplicationPageMu = useApplicationPageMutation(function (_ref) {
      var requirementId = _ref.requirementId,
        attachmentId = _ref.attachmentId;
      return {
        url: "/awa/v1/application_requirements/".concat(requirementId, "/attachments/").concat(attachmentId),
        method: 'DELETE'
      };
    }),
    mutate = _useApplicationPageMu.mutate,
    isLoading = _useApplicationPageMu.isLoading;
  return {
    deleteRequirementAttachments: mutate,
    isDeletingRequirementAttachments: isLoading
  };
}
export var PiiDeleteRequestBody = z.object({
  data: z.array(z.object({
    id: z.string(),
    type: z.literal('attachment')
  }))
});
export function useDeleteApplicationRequirementAttachmentForPii() {
  var _useApplicationPageMu2 = useApplicationPageMutation(function (attachmentId) {
      var requestBody = {
        data: [{
          id: attachmentId,
          type: 'attachment'
        }]
      };
      return {
        url: '/awa/v1/pii_center/attachments',
        method: 'DELETE',
        body: requestBody
      };
    }),
    mutate = _useApplicationPageMu2.mutate,
    isLoading = _useApplicationPageMu2.isLoading;
  return {
    deleteAttachmentForPii: mutate,
    isDeletingAttachmentForPii: isLoading
  };
}